import React from 'react';
import { History } from 'history';
import { Input, InputMultiline, InputSelect, InputTime, InputSwitch, InputPicklist } from '../../components';
import BaseDelete from '../base/base-delete.component'; 
import Model from './schedule-model';  //editable..
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class ScheduleDelete extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    render() {
        return (
            //editable..
            <BaseDelete history={this.props.history} 
                model={Model} onLoad={this.onLoad}>              
                
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} readOnly/>
                <Input name='name' label='Name' value={this.state.datarow.name} readOnly/>
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} readOnly/>
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} readOnly/>
                }                
                <InputSelect name='day' label='Day' value={this.state.datarow.day} options={Model.optionDay} readOnly/>
                <InputTime name='time' label='Time' value={this.state.datarow.time} readOnly/>
                <InputPicklist name='division' label='Division' value='' caption={this.state.datarow.divisionCaption} readOnly/>
            </BaseDelete>
        );
    }
}